module.exports = __webpack_public_path__ + "img/pouzecem.3c1e48ce.png";